














import { Component, Vue, Prop } from 'vue-property-decorator';
import ITeamMember from '@/store/modules/contact/types/ITeamMember';

@Component
export default class TeamMember extends Vue implements ITeamMember {
  @Prop({ type: String, required: true }) public names!: string;
  @Prop({ type: String, required: true }) public email!: string;
  @Prop({ type: String, required: true }) public phone!: string;
  @Prop({ type: String, required: true }) public picture!: string;
  @Prop({ type: String, required: true }) public destinations!: string;
}
